import Stamp from '../../../types/api/stamp'

export default function getTeeth(stampRoller?: Stamp['roller']) {
    if (!stampRoller) return

    return Math.round(stampRoller.shaft / 3.175)
}
